import Vue from 'vue';
import Vuex from 'vuex';

import modules from '@/store/modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state: {
    modalVisible: false,
    modalComponent: null,
  },
  mutations: {
    showModal(state, modal) {
      state.modalVisible = true;
      state.modalComponent = modal;
    },
    hideModal(state) {
      state.modalVisible = false;
    },
  },
  modules,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js